// @flow
import { theme } from "../theme";

const transform = (inverted) =>
  inverted ? "scale(1, -1) translate(0, -32)" : "";

type Props = {
  className?: string,
  inverted: boolean,
  fill?: string,
};

// This is the raw SVG version of the design from Zeplin
export const Chevron = ({
  className = "",
  inverted,
  fill = theme.palette.navy.dark,
}: Props) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <path
      transform={transform(inverted)}
      fill={fill}
      fillRule="evenodd"
      d="M16 23C15.7197 23 15.4523 22.8824 15.2628 22.6757L4.26284 10.6757C3.88965 10.2686 3.91715 9.63604 4.32427 9.26285C4.73139 8.88965 5.36396 8.91716 5.73715 9.32428L16 20.5201L26.2628 9.32428C26.636 8.91716 27.2686 8.88965 27.6757 9.26285C28.0828 9.63604 28.1103 10.2686 27.7371 10.6757L16.7371 22.6757C16.5477 22.8824 16.2803 23 16 23Z"
    />
  </svg>
);
